import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 13 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 13 10\" id=\"check\">\r\n<polyline points=\"\r\n\t1.219,3.902 5.151,8.969 11.844,1.028 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol